/**
 * @generated SignedSource<<cc0f1822c45163ae9e0a70e36fed4ab4>>
 * @relayHash 40641bb3e28814da75e7a2ef44a3a696
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1484947807387ce99021a50116c181e9dda21bf126c1582a6f11d6b77de0473b

import type { ConcreteRequest, Mutation } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraNotificationChannelType = "EMAIL" | "IN_PRODUCT" | "MOBILE_PUSH" | "SLACK" | "%future added value";
export type JiraNotificationType = "COMMENT_CREATED" | "COMMENT_DELETED" | "COMMENT_EDITED" | "DAILY_DUE_DATE_NOTIFICATION" | "ISSUE_ASSIGNED" | "ISSUE_CREATED" | "ISSUE_DELETED" | "ISSUE_MOVED" | "ISSUE_UPDATED" | "MENTIONS_COMBINED" | "MISCELLANEOUS_ISSUE_EVENT_COMBINED" | "PROJECT_INVITER_NOTIFICATION" | "WORKLOG_COMBINED" | "%future added value";
export type JiraUpdateProjectNotificationPreferencesInput = {
  preferences: ReadonlyArray<JiraNotificationPreferenceInput>;
  projectId: string;
};
export type JiraNotificationPreferenceInput = {
  channel?: JiraNotificationChannelType | null | undefined;
  channelsEnabled?: ReadonlyArray<JiraNotificationChannelType> | null | undefined;
  isEnabled?: boolean | null | undefined;
  type: JiraNotificationType;
};
export type projectNotificationsConfigHead_HeadCheckbox_updateProjectPreferencesMutation$variables = {
  cloudId: string;
  input: JiraUpdateProjectNotificationPreferencesInput;
};
export type projectNotificationsConfigHead_HeadCheckbox_updateProjectPreferencesMutation$data = {
  readonly jira: {
    readonly updateProjectNotificationPreferences: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly preferences: {
        readonly " $fragmentSpreads": FragmentRefs<"notificationsConfigHead_personalSettingsNotificationsConfigTable_HeadCheckbox_allPreferences">;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type projectNotificationsConfigHead_HeadCheckbox_updateProjectPreferencesMutation = {
  response: projectNotificationsConfigHead_HeadCheckbox_updateProjectPreferencesMutation$data;
  variables: projectNotificationsConfigHead_HeadCheckbox_updateProjectPreferencesMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "concreteType": "MutationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "message"
    }
  ]
},
v4 = [
  {
    "kind": "ScalarField",
    "name": "channel"
  },
  {
    "kind": "ScalarField",
    "name": "isEnabled"
  },
  {
    "kind": "ScalarField",
    "name": "isEditable"
  }
],
v5 = [
  {
    "kind": "ScalarField",
    "name": "id"
  },
  {
    "kind": "ScalarField",
    "name": "type"
  },
  {
    "concreteType": "JiraNotificationChannel",
    "kind": "LinkedField",
    "name": "emailChannel",
    "plural": false,
    "selections": (v4/*: any*/)
  },
  {
    "concreteType": "JiraNotificationChannel",
    "kind": "LinkedField",
    "name": "inProductChannel",
    "plural": false,
    "selections": (v4/*: any*/)
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "projectNotificationsConfigHead_HeadCheckbox_updateProjectPreferencesMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraUpdateProjectNotificationPreferencesPayload",
            "kind": "LinkedField",
            "name": "updateProjectNotificationPreferences",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "JiraNotificationPreferences",
                "kind": "LinkedField",
                "name": "preferences",
                "plural": false,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "notificationsConfigHead_personalSettingsNotificationsConfigTable_HeadCheckbox_allPreferences"
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "projectNotificationsConfigHead_HeadCheckbox_updateProjectPreferencesMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraUpdateProjectNotificationPreferencesPayload",
            "kind": "LinkedField",
            "name": "updateProjectNotificationPreferences",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "JiraNotificationPreferences",
                "kind": "LinkedField",
                "name": "preferences",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "issueAssigned",
                    "plural": false,
                    "selections": (v5/*: any*/)
                  },
                  {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "issueUpdated",
                    "plural": false,
                    "selections": (v5/*: any*/)
                  },
                  {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "issueDeleted",
                    "plural": false,
                    "selections": (v5/*: any*/)
                  },
                  {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "commentCreated",
                    "plural": false,
                    "selections": (v5/*: any*/)
                  },
                  {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "commentEdited",
                    "plural": false,
                    "selections": (v5/*: any*/)
                  },
                  {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "commentDeleted",
                    "plural": false,
                    "selections": (v5/*: any*/)
                  },
                  {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "issueCreated",
                    "plural": false,
                    "selections": (v5/*: any*/)
                  },
                  {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "issueMoved",
                    "plural": false,
                    "selections": (v5/*: any*/)
                  },
                  {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "mentionsCombined",
                    "plural": false,
                    "selections": (v5/*: any*/)
                  },
                  {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "worklogCombined",
                    "plural": false,
                    "selections": (v5/*: any*/)
                  },
                  {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "miscellaneousIssueEventCombined",
                    "plural": false,
                    "selections": (v5/*: any*/)
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "1484947807387ce99021a50116c181e9dda21bf126c1582a6f11d6b77de0473b",
    "metadata": {},
    "name": "projectNotificationsConfigHead_HeadCheckbox_updateProjectPreferencesMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "3aa6007c01d7a3f03378110552b2cc76";

export default node;
